'use client';
import { useEffect, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';

interface PageLoaderProps {
  message?: string;
}

export default function PageLoader({ message = 'লোড হচ্ছে...' }: PageLoaderProps) {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 400);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/95 backdrop-blur-sm page-loader-enter">
      {/* Pulsing logo */}
      <div className="relative mb-6">
        <div className="absolute inset-0 rounded-full bg-green-200 animate-ping opacity-40 scale-150" />
        <div className="relative w-16 h-16 rounded-full bg-green-50 border-2 border-green-200 flex items-center justify-center shadow-lg">
          <AppLogo size={36} />
        </div>
      </div>

      {/* Spinner ring */}
      <div className="relative w-12 h-12 mb-5">
        <div className="absolute inset-0 rounded-full border-4 border-green-100" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-green-600 animate-spin" />
        <div className="absolute inset-1 rounded-full border-2 border-transparent border-t-green-400 animate-spin" style={{ animationDuration: '0.6s', animationDirection: 'reverse' }} />
      </div>

      {/* Progress bar */}
      <div className="w-48 h-1.5 bg-green-100 rounded-full overflow-hidden mb-4">
        <div className="h-full bg-gradient-to-r from-green-400 to-green-600 rounded-full page-loader-progress" />
      </div>

      {/* Status text */}
      <p className="text-sm font-medium text-green-700 tracking-wide">
        {message}<span className="inline-block w-6 text-left">{dots}</span>
      </p>
    </div>
  );
}
